import { useEffect } from "react";
import LandingNav from "@/components/landing/LandingNav";
import LandingFooter from "@/components/landing/LandingFooter";
import PricingSection from "@/components/landing/PricingSection";

/**
 * Public pricing page for the paid HeirWise product. Four canonical plans,
 * no free trial. Entitlement is only ever created by a completed Stripe
 * subscription reaching the backend webhook.
 */
export default function Pricing() {
  useEffect(() => {
    document.title = "Pricing | HeirWise — Economic & Enterprise Education";
  }, []);

  return (
    <div className="theme-light min-h-screen bg-background">
      <LandingNav />
      <main className="pt-20">
        <h1 className="sr-only">HeirWise pricing</h1>
        <PricingSection />
      </main>
      <LandingFooter />
    </div>
  );
}
